export const Marketplace = [
  {
    path: '/marketplace/:app_module_id',
    name: 'marketplace.index',
    component: () => import('@/pages/Marketplace/MarketplaceModule')
  },
  {
    path: '/marketplace/:app_module_id/:id',
    name: 'marketplace.item',
    component: () => import('@/pages/Marketplace/MarketplacePage')
  },
]
